export default "__VITE_ASSET__DLalL1n3__"